export function Footer() {
  return (
    <footer className="bg-gradient-to-r from-emerald-500 to-teal-600 py-6 md:py-8 lg:py-12">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="flex flex-col items-center gap-3 md:gap-4 lg:gap-6 text-center">
          <div className="flex items-center gap-3 md:gap-4 lg:gap-6">
            <a
              href="https://www.facebook.com/profile.php?id=61578144032566"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 transform hover:scale-110 cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl md:text-2xl text-white"></i>
            </a>
            <a
              href="https://www.youtube.com/@ESAULLORENZO"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 transform hover:scale-110 cursor-pointer"
            >
              <i className="ri-youtube-fill text-xl md:text-2xl text-white"></i>
            </a>
            <a
              href="https://www.instagram.com/esaullorenzo/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 transform hover:scale-110 cursor-pointer"
            >
              <i className="ri-instagram-fill text-xl md:text-2xl text-white"></i>
            </a>
          </div>
          <p className="text-white/90 text-xs sm:text-sm">
            © Copyright 2026 Método ScaleUp. Todos los derechos reservados.
          </p>
          <p className="text-white/70 text-xs sm:text-sm">
            Desarrollado por <span className="font-semibold">Esaúl Lorenzo</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
